import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2064c9cb")

_pushScopeId("data-v-2064c9cb")
const _hoisted_1 = { class: "managerDetail" }
const _hoisted_2 = { class: "p-grid p-m-3 p-fluid p-ai-start" }
const _hoisted_3 = { class: "p-float-label p-col-4" }
const _hoisted_4 = {
  class: "kn-material-input-label",
  for: "name"
}
const _hoisted_5 = { class: "p-float-label p-col-2" }
const _hoisted_6 = {
  class: "kn-material-input-label",
  for: "name"
}
const _hoisted_7 = { class: "p-float-label p-col-3" }
const _hoisted_8 = {
  class: "kn-material-input-label",
  for: "outputType"
}
const _hoisted_9 = { class: "p-col-3 p-d-flex p-jc-end" }
const _hoisted_10 = {
  class: "kn-material-input-label p-mr-2",
  for: "name"
}
const _hoisted_11 = { class: "p-float-label p-col-8 descriptionTextArea" }
const _hoisted_12 = {
  class: "kn-material-input-label",
  for: "description"
}
const _hoisted_13 = { class: "p-col-4 kn-height-full" }
const _hoisted_14 = { class: "p-d-flex p-jc-end p-ai-center" }
const _hoisted_15 = { for: "inputImage" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0 pi pi-upload" }, null, -1)
const _hoisted_17 = { class: "imageContainer p-d-flex p-jc-center p-ai-center" }
const _hoisted_18 = {
  key: 0,
  class: "far fa-image fa-5x icon"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      class: "kn-dialog--toolbar--primary knMetadataDialog",
      visible: _ctx.visibility,
      footer: "footer",
      header: _ctx.$t('managers.resourceManagement.metadata.dialog.title'),
      closable: false,
      modal: "",
      onId: _ctx.loadMetadata
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--secondary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.saveMetadata,
          disabled: !_ctx.dirty
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.metadata.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.metadata.name = $event)),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "onChange"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')), 1)
          ]),
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_InputText, {
              id: "name",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.metadata.version,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.metadata.version = $event)),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "onChange"]),
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.descriptor.metadata.version.label)), 1)
          ]),
          _createVNode("span", _hoisted_7, [
            _createVNode(_component_Dropdown, {
              id: "typeOfAnalytics",
              class: "kn-material-input",
              modelValue: _ctx.metadata.typeOfAnalytics,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.metadata.typeOfAnalytics = $event)),
              onChange: _ctx.setDirty,
              options: _ctx.translatedOptions,
              optionLabel: "name",
              optionValue: "value"
            }, null, 8, ["modelValue", "onChange", "options"]),
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t(_ctx.descriptor.metadata.typeOfAnalytics.label)), 1)
          ]),
          _createVNode("span", _hoisted_9, [
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.descriptor.metadata.openSource.label)), 1),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.metadata.openSource,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.metadata.openSource = $event)),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "onChange"])
          ]),
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.metadata.description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.metadata.description = $event)),
              class: "kn-material-input ",
              style: {"resize":"none"},
              id: "description",
              rows: "5",
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "onChange"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.description')), 1)
          ]),
          _createVNode("span", _hoisted_13, [
            _createVNode("span", _hoisted_14, [
              _createVNode("input", {
                id: "inputImage",
                type: "file",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                accept: "image/png, image/jpeg"
              }, null, 32),
              _withDirectives(_createVNode("label", _hoisted_15, [
                _hoisted_16
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.upload'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              (_ctx.metadata.image)
                ? _withDirectives((_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0 pi pi-times p-ml-2",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)))
                  }, null, 512)), [
                    [
                      _directive_tooltip,
                      _ctx.$t('common.delete'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_17, [
              (!_ctx.metadata.image)
                ? (_openBlock(), _createBlock("i", _hoisted_18))
                : _createCommentVNode("", true),
              (_ctx.metadata.image)
                ? (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _ctx.metadata.image,
                    height: "100%",
                    class: "kn-no-select"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode(_component_Accordion, { class: "p-col-12" }, {
          default: _withId(() => [
            _createVNode(_component_AccordionTab, {
              header: _ctx.$t(_ctx.descriptor.metadata.accuracyAndPerformance.label)
            }, {
              default: _withId(() => [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.metadata.accuracyAndPerformance,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.metadata.accuracyAndPerformance = $event)),
                  class: "kn-material-input metadataTextArea",
                  style: {"resize":"none"},
                  id: "accuracyAndPerformance",
                  rows: "3",
                  onChange: _ctx.setDirty
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_AccordionTab, {
              header: _ctx.$t(_ctx.descriptor.metadata.usageOfTheModel.label)
            }, {
              default: _withId(() => [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.metadata.usageOfTheModel,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.metadata.usageOfTheModel = $event)),
                  class: "kn-material-input metadataTextArea",
                  style: {"resize":"none"},
                  id: "usageOfTheModel",
                  rows: "3",
                  onChange: _ctx.setDirty
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_AccordionTab, {
              header: _ctx.$t(_ctx.descriptor.metadata.formatOfData.label)
            }, {
              default: _withId(() => [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.metadata.formatOfData,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.metadata.formatOfData = $event)),
                  class: "kn-material-input metadataTextArea",
                  style: {"resize":"none"},
                  id: "formatOfData",
                  rows: "3",
                  onChange: _ctx.setDirty
                }, null, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "header", "onId"])
  ]))
})